export const DEFAULT_CUSTOMER_ID = '016551d5-7095-47c0-a46b-fd0cb9bf4c72'
export const DEFAULT_PLAYER_ID = '48772c3c-b63e-4cb1-a1e4-14ed9830e8c7'
